import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Features from './pages/Features';
import HowItWorks from './pages/HowItWorks';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Download from './pages/Download';
import Screenshots from './pages/Screenshots';
import Pricing from './pages/Pricing';
import AnalyticsConsent from './components/AnalyticsConsent';
import { trackPageView } from './analytics';
import './App.css';

export function AnalyticsPageTracker() {
  const location = useLocation();

  React.useEffect(() => {
    trackPageView(location.pathname, location.search);
  }, [location.pathname, location.search]);

  return null;
}

function App() {
  return (
    <Router>
      <div className="App">
        <AnalyticsPageTracker />
        <Routes>
          <Route path="" element={<Home />} />
          <Route path="/features" element={<Features />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/download" element={<Download />} />
          <Route path="/screenshots" element={<Screenshots />} />
        </Routes>
        <AnalyticsConsent />
      </div>
    </Router>
  );
}

export default App;
